/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Initiate withdraw request
 */
export interface InitiateWithdrawRequest {
  /**
   * Main account or subaccount ID. Main account is used if not set
   */
  accountId?: number;
  /**
   * Asset Code
   */
  assetCode: string;
  /**
   * Withdraw address ID
   */
  addressId: number;
  /**
   * Transfer quantity
   */
  quantity: number;
  /**
   * Transfers quantity can be reduced to this level.
   */
  allowReduceQuantityTo?: number;
}
